<div
  class="login-signup-container container"
  *appLet="{
    error: logInError$ | async,
    genders: genders$ | async,
    phoneCodes: phoneCodes$ | async,
    featIsOnUS1732: gbs.growthBook.isOn('feat-001732-input-field-cleanup') && gbs.growthBook.getFeatureValue('feat-001732-input-field-cleanup', '') === 'b',
  } as $comp"
>
  <button
    id="btnClose"
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
  <div class="row">
    <div class="col-12">
      <img
        class="header-image"
        src="https://assets.flynorse.com/static/site/NorseLogo.svg"
      />
    </div>
  </div>
  <div class="row" *ngIf="activeTab && !!tabs[activeTab]">
    <div class="col-12">
      <app-tabs
        [tabs]="tabs"
        [activeTab]="activeTab"
        (tabClick)="onTabClicked($event)"
      ></app-tabs>
    </div>
  </div>
  <ng-container [ngSwitch]="activeTab">
    <div *ngSwitchCase="'reset'" class="row">
      <form
        class="col col-12"
        (ngSubmit)="onResetPassword($event)"
        [formGroup]="resetPasswordForm"
        [class.form--submitted]="$comp.featIsOnUS1732 && submitted"
        [class.form--custom]="$comp.featIsOnUS1732"
      >
        <div class="modal-body">
          <div
            *ngIf="
              $comp.error &&
              $comp.error.type === ErrorType.LoginValidationFailure
            "
            class="col-12 login-error danger"
          >
            {{ loginCopy.invalidLogin }}
          </div>
          <div class="row mb-2">
            <div class="col col-12 mb-2">
              <h5 class="fw-bold mb-0">
                {{ loginCopy.resetPasswordTitleCopy }}
              </h5>
              <p>
                {{ loginCopy.resetPasswordInfoCopy }}
              </p>
            </div>
            <div class="col-12">
              <app-input
                [label]="loginCopy.usernameLabel"
                [control]="resetPasswordForm.get('username')"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="text"
                  name="username"
                  formControlName="username"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!loginForm.controls.username.errors"
                />
              </app-input>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-12">
              <app-input>
                <input
                  appInput
                  type="submit"
                  name="login"
                  class="w-100"
                  [value]="loginCopy.loginCta"
                />
              </app-input>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div *ngSwitchCase="'resetSubmitted'" class="row">
      <div class="col">
        <div class="modal-body">
          <div
            *ngIf="
              $comp.error &&
              $comp.error.type === ErrorType.LoginValidationFailure
            "
            class="col-12 login-error danger"
          >
            {{ loginCopy.invalidLogin }}
          </div>
          <div class="row mb-2">
            <div class="col col-12 mb-2">
              <h5 class="fw-bold mb-0">
                {{ loginCopy.resetPasswordTitleCopy }}
              </h5>
              <p>
                {{ loginCopy.resetPasswordSumittedCopy }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="'signUp'" class="row">
      <form
        *ngIf="signUpForm && $comp.phoneCodes"
        class="col col-12"
        (ngSubmit)="onSignUp($comp.phoneCodes)"
        [formGroup]="signUpForm"
        [class.form--submitted]="$comp.featIsOnUS1732 && submitted"
        [class.form--custom]="$comp.featIsOnUS1732"
      >
        <div class="modal-body">
          <div
            *ngIf="
              $comp.error &&
              $comp.error.type === ErrorType.SignUpValidationFailure
            "
            class="col-12 login-error danger"
          >
            {{ loginCopy.invalidSignUpCopy }}
          </div>
          <div class="row mb-2 g-2">
            <div class="col col-12 mb-2">
              <h5 class="fw-bold mb-0">
                {{ loginCopy.signUpTitleCopy }}
              </h5>
              <p>
                {{ loginCopy.signUpCopy }}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <app-input
                [label]="loginCopy.firstNameCopy"
                [control]="signUpForm.controls.firstName"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="text"
                  name="firstName"
                  formControlName="firstName"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls.firstName.errors"
                />
              </app-input>
            </div>
            <div class="col-12 col-md-6">
              <app-input
                [label]="loginCopy.lastNameCopy"
                [control]="signUpForm.controls.lastName"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="text"
                  name="lastName"
                  formControlName="lastName"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls.lastName.errors"
                />
              </app-input>
            </div>
          </div>
          <div class="row mb-2 g-2">
            <div class="col-12 col-md-6">
              <app-select
                [label]="loginCopy.genderCopy"
                [value]="
                  signUpForm.controls.gender.value
                    ? signUpForm.controls.gender.value.toString()
                    : ''
                "
                [items]="$comp.genders"
                [control]="signUpForm.controls.gender"
                name="gender"
                textKey="description"
                valueKey="code"
                required
                [customInput]="$comp.featIsOnUS1732"
              >
              </app-select>
            </div>
            <div class="col-12 col-md-6" *appLet="'birthDate' as controlName">
              <app-input
                [label]="loginCopy.birthDateCopy"
                [control]="signUpForm.controls.birthDate"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  appDateInput
                  type="text"
                  [name]="controlName"
                  [formControlName]="controlName"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls[controlName]?.errors"
                />
              </app-input>
            </div>
          </div>
          <div class="row mb-2 g-2">
            <div class="col-12 col-md-6">
              <app-select
                name="phoneCountryCode"
                [value]="signUpForm.controls.phoneCountryCode.value"
                [label]="loginCopy.phoneCodeCopy"
                [items]="$comp.phoneCodes"
                [control]="signUpForm.controls.phoneCountryCode"
                textKey="name"
                valueKey="countryCode"
                required
                [customInput]="$comp.featIsOnUS1732"
              >
              </app-select>
            </div>
            <div class="col" *appLet="'phoneNumber' as controlName">
              <app-input
                [label]="loginCopy.phoneNumberCopy"
                [control]="signUpForm.controls.phoneNumber"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="tel"
                  [name]="controlName"
                  [formControlName]="controlName"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls[controlName]?.errors"
                />
              </app-input>
            </div>
          </div>
          <div class="row mb-2 g-2">
            <div class="col-12 col-md-6">
              <app-input
                [label]="loginCopy.emailCopy"
                [control]="signUpForm.controls.email"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="email"
                  name="email"
                  formControlName="email"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls.email.errors"
                />
              </app-input>
            </div>
            <div class="col-12 col-md-6">
              <app-input
                [label]="loginCopy.emailConfirmationCopy"
                [control]="signUpForm.controls.confirmEmail"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="email"
                  name="confirmEmail"
                  formControlName="confirmEmail"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls.confirmEmail.errors"
                />
              </app-input>
          </div>
          </div>
          <div class="row mb-2 g-2">
            <div class="col-12 col-md-6">
              <app-input
                [label]="loginCopy.passwordCopy"
                [control]="signUpForm.controls.password"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="password"
                  name="password"
                  formControlName="password"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls.password.errors"
                />
              </app-input>
            </div>
            <div class="col-12 col-md-6">
              <app-input
                [label]="loginCopy.passwordConfirmationCopy"
                [control]="signUpForm.controls.confirmPassword"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="password"
                  name="confirmPassword"
                  formControlName="confirmPassword"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls.password.errors"
                />
              </app-input>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <app-input
                [label]="loginCopy.receiveNotifications"
                [control]="signUpForm.controls.receiveMarketingNotifications"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="checkbox"
                  name="receiveMarketingNotifications"
                  formControlName="receiveMarketingNotifications"
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!signUpForm.controls.receiveMarketingNotifications.errors"
                />
              </app-input>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-12">
              <ul>
                <h6>{{ loginCopy.passwordHintCopy }}</h6>
                <li *ngFor="let hint of passwordHints">
                  {{ hint }}
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-input>
                <input
                  appInput
                  type="submit"
                  name="login"
                  class="w-100"
                  [value]="loginCopy.loginCta"
                />
              </app-input>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div *ngSwitchDefault class="row">
      <form
        class="col col-12"
        (ngSubmit)="onLogin($event)"
        [formGroup]="loginForm"
        [class.form--submitted]="$comp.featIsOnUS1732 && submitted"
        [class.form--custom]="$comp.featIsOnUS1732"
      >
        <div class="modal-body">
          <div *ngIf="$comp.error" class="col-12 login-error danger">
            <ng-container [ngSwitch]="$comp.error.type">
              <ng-container *ngSwitchCase="ErrorType.LoginValidationFailure">
                {{ loginCopy.invalidLogin }}
              </ng-container>
              <ng-container
                *ngSwitchCase="ErrorType.LoginCodeValidationFailure"
              >
                {{ loginCopy.verificationFailed }}
              </ng-container>
            </ng-container>
          </div>
          <div class="row mb-2">
            <div class="col col-12 mb-2">
              <h5 class="fw-bold mb-0">
                {{ loginCopy.existingUserTitleCopy }}
              </h5>
              <p>
                {{ loginCopy.alreadyHaveAnAccountCopy }}
              </p>
            </div>
            <div class="col-12">
              <app-input
                [label]="loginCopy.usernameLabel"
                [control]="loginForm.get('username')"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="text"
                  name="username"
                  formControlName="username"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!loginForm.controls.username.errors"
                />
              </app-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-input
                [label]="loginCopy.passwordLabel"
                [control]="loginForm.get('password')"
                [customInput]="$comp.featIsOnUS1732"
              >
                <input
                  appInput
                  type="password"
                  name="password"
                  formControlName="password"
                  required
                  [class.input--custom]="$comp.featIsOnUS1732"
                  [class.input--error]="$comp.featIsOnUS1732 && !!loginForm.controls.username.errors"
                />
              </app-input>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div
            *ngIf="
              featureFlagService.isFeatureActive(
                FeatureFlagsEnum.FORGOT_PASSWORD
              )
            "
            class="row"
          >
            <div class="col-12">
              <button
                type="button"
                class="btn btn-link in-text"
                (click)="onTabClicked('reset')"
              >
                {{ loginCopy.forgotPasswordCopy }}
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-input>
                <input
                  appInput
                  type="submit"
                  name="login"
                  class="w-100"
                  [value]="loginCopy.loginCta"
                />
              </app-input>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-container>
</div>
